// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"collection-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 14L21 3L3 3L2 14M17.5 8H6.5M17.5 12.5H6.5M22 17.5L2 17.5L3 21H21L22 17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Collection1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'collection-1',
    ref,
    icon: element,
  },
));

Collection1Icon.displayName = 'Collection1Icon';

export default Collection1Icon;
